<template>
    <el-dialog custom-class="send_report_dialog" :model-value="show" title="移动到收藏夹" width="422px" top="5vh" destroy-on-close :lock-scroll="false" @close="handleClose" @open="handleOpen">
        <div class="move_coll_dialog_content" v-loading="loading">
            <div class="close" @click="handleClose">
                <Close class="icon" />
            </div>
            <div class="title_iocn"><i class="iconfont icon-qunzu"></i></div>
            <h1>发送报告</h1>
            <h2>请选择收件人</h2>
            <div class="search_input">
                <i class="iconfont icon-sousuo"></i>
                <input type="text" placeholder="搜索公司/人" v-model.trim="keyword" />
            </div>
            <ul class="list scrollbar">
                <el-tree ref="treeRef" style="width: 100%" :data="groups" show-checkbox default-expand-all node-key="id" highlight-current :props="{ label: 'name', children: 'recipientList' }" :filter-node-method="filterNode" @check-change="handleCheckChange">
                    <template #default="{ node, data }">
                        <span>{{ node.label }}</span>
                        <span v-if="data.email">（{{ data.email }}）</span>
                    </template>
                </el-tree>
            </ul>
            <div class="btn_row">
                <el-checkbox v-model="isNew" label="发送最新舆情" v-if="isShowNew" />
                <el-button type="primary" @click="onSubmit" :loading="loading">发送</el-button>
            </div>
            <div class="recipient">
                <router-link to="/recipient" class="recipient_box">
                    <div class="icon">
                        <i class="iconfont icon-qunzu"></i>
                    </div>
                    <span>管理收件人</span>
                </router-link>
            </div>
        </div>
    </el-dialog>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import { Close } from "@element-plus/icons-vue";
import { cloneDeep } from "loadsh";
import { apiFavoriteEmail } from "@/request/api";
import { ElMessage } from "element-plus";

const props = defineProps({
    show: { type: Boolean, default: false },
    groupDict: { type: Array, default: [] },
    favoriteId: { type: [Number, String], required: true },
    articleIdList: { type: Array, default: [] },
});
const emits = defineEmits(["close", "success"]);
const keyword = ref("");
const loading = ref(false);
const treeRef = ref();
const checked = ref([]); // 选中的节点对象集合
const groups = ref([]); // 所有分组和人
const isNew = ref(true); // 是否发送最新舆情
const isShowNew = computed(() => {
    // 没有选中文章时才显示 是否发送最新舆情
    return !props.articleIdList.length;
});
watch(
    () => keyword.value,
    (newVal) => {
        treeRef.value && treeRef.value.filter(newVal);
    }
);

// 计算选中数量
function calcChecked() {
    groups.value.forEach((item) => {
        function getCheckNum(arr) {
            let count = 0;
            const ids = checked.value.map((c) => c.id); // 已选中的id集合
            arr.forEach((item) => {
                if (ids.includes(item.id)) {
                    count++;
                }
            });
            return count;
        }
        item.checkNum = getCheckNum(item.recipientList || []);
        if (item.checkNum) {
            item.name = item.groupName + `(选中${item.checkNum})`;
        } else {
            item.name = item.groupName;
        }
    });
}

// 选中
function handleCheckChange(a, b, c) {
    const res = treeRef.value.getCheckedNodes();
    checked.value = res?.filter((item) => item.email) || [];
    calcChecked();
}

// 过滤节点
const filterNode = (value, data) => {
    if (!value) return true;
    return data.name.includes(value);
};

// 提交
async function onSubmit() {
    if (!checked.value.length) {
        ElMessage.error("请选择收件人");
        return;
    }
    loading.value = true;
    try {
        const params = {
            expire: 30,
            favoriteId: props.favoriteId,
            isNew: isNew.value,
            articleIdList: props.articleIdList,
            shareLink: window.location.origin + "/details?",
        };
        params.recipientList = checked.value.map((item) => {
            return {
                id: item.id,
                name: item.name,
                value: item.email,
            };
        });
        const { code } = await apiFavoriteEmail(params);
        if (code !== "0") return;
        ElMessage.success("发送成功");
        handleClose();
    } finally {
        loading.value = false;
    }
}

// 打开
function handleOpen() {
    groups.value = cloneDeep(props.groupDict);
}

// 关闭
function handleClose() {
    groups.value = [];
    checked.value = [];
    isNew.value = true;
    loading.value = false;
    emits("close");
}
</script>

<style lang="scss">
.send_report_dialog {
    border-radius: 16px;
    .el-dialog__header {
        display: none;
    }
    .el-dialog__body {
        padding: 0;
    }
    .move_coll_dialog_content {
        padding: 34px 34px 0 34px;
        position: relative;
        text-align: center;
        .close {
            position: absolute;
            top: 32px;
            right: 32px;
            cursor: pointer;
            .icon {
                width: 24px;
                height: 24px;
            }
        }
        .title_iocn {
            width: 68px;
            height: 68px;
            border-radius: 8px;
            background-color: #ff5a00;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            .iconfont {
                color: #fff;
                font-size: 24px;
            }
        }
        h1 {
            color: #2a2a2a;
            font-size: 24px;
            line-height: 28px;
            margin-top: 24px;
            font-weight: 400;
        }
        h2 {
            color: #727272;
            font-size: 14px;
            line-height: 28px;
            margin-top: 16px;
            font-weight: 400;
            padding: 0 27px;
            span {
                color: #2a2a2a;
            }
        }
        .search_input {
            height: 48px;
            border-radius: 24px;
            background-color: #f5f5f5;
            display: flex;
            align-items: center;
            padding-left: 21px;
            margin-top: 16px;
            .iconfont {
                font-size: 26px;
                color: #979797;
            }
            input {
                height: 100%;
                line-height: 48px;
                background: none;
                flex: 1;
                padding: 0 20px;
                border: none;
                font-size: 18px;
            }
        }
        .list {
            margin-top: 16px;
            height: 240px;
            overflow-y: auto;
            border-bottom: 1px solid #d8d8d8;
            li {
                display: flex;
                justify-content: space-between;
                align-items: center;
                position: relative;
                height: 48px;
                border-radius: 8px;
                padding-left: 16px;
                padding-right: 10px;
                transition: all 0.3s;
                p.no {
                    text-align: center;
                    display: block;
                    width: 100%;
                }
                .name {
                    font-size: 14px;
                    color: #2a2a2a;
                }
                .num {
                    font-size: 14px;
                    color: #727272;
                }
                .btn {
                    position: absolute;
                    height: 44px;
                    width: 64px;
                    background-color: var(--primary-color);
                    color: #fff;
                    text-align: center;
                    line-height: 44px;
                    border-radius: 8px;
                    top: 2px;
                    right: 2px;
                    cursor: pointer;
                    display: none;
                }
                &:has(:not(.no)):hover {
                    background-color: #ffeee4;
                    .btn {
                        display: block;
                    }
                }
            }
        }
        .btn_row {
            display: flex;
            flex-direction: column;
            .el-checkbox {
                margin: 5px 0;
            }
        }
        .recipient {
            .recipient_box {
                display: flex;
                padding: 15px 0;
                cursor: pointer;
                .icon {
                    width: 20px;
                    height: 20px;
                    background-color: var(--primary-color);
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .iconfont {
                        color: #fff;
                        font-size: 12px;
                    }
                }
                span {
                    padding-left: 5px;
                }
            }
        }
    }
}
.el-tree-node__content {
    height: 30px;
}
.el-tree-node__label {
    font-size: 16px;
}
</style>
